module.exports = __webpack_public_path__ + "static/media/image-not-found.58dd3b98.svg";